import React from "react";

const LiknExpiredComp = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold">Link Expired</h1>
      <p>Please scan the QR of an active session to fill out the Survey</p>
    </div>
  );
};

export default LiknExpiredComp;
